import { render, staticRenderFns } from "./TaskReview.vue?vue&type=template&id=7541b384&"
import script from "./TaskReview.vue?vue&type=script&lang=js&"
export * from "./TaskReview.vue?vue&type=script&lang=js&"
import style0 from "./TaskReview.vue?vue&type=style&index=0&id=7541b384&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports